import * as amplitudeBrowser from '@amplitude/analytics-browser';

export const amplitudeLogger = (amplitudeConfig: Record<string, any>) => ({
  track: (
    eventInput: string | amplitudeBrowser.Types.BaseEvent,
    eventProperties?: Record<string, any>,
  ) =>
    amplitudeBrowser.track(eventInput, {
      ...amplitudeConfig,
      ...eventProperties,
    }),
});
